import { SelectOption } from '@components/select';
import {
  BaseFieldMappingFieldProps,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { SingleField } from '@components/text-editors/addons/single-field';
import { NodeStyledFieldMappingTextEditor } from '@components/text-editors/field-mapping-text-editor';
import { useScopedTranslate } from '@locale/translate';

import { SelectPlaceholder, tag, transformInput } from './extensions';

export type FieldMappingSelectFieldProps = BaseFieldMappingFieldProps & {
  options: SelectOption[];
} & FieldMappingData;

export const FieldMappingSelectField = ({
  defaultValue,
  onChange,
  options,
  ...rest
}: FieldMappingSelectFieldProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <NodeStyledFieldMappingTextEditor
      extensions={[SelectPlaceholder, SingleField]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag)[0])}
      defaultValue={defaultValue ? transformInput([defaultValue], options) : undefined}
      placeholder={t('placeholder')}
      disabled
      shouldShowFieldMappingOnFocus
      fieldType="select"
      manualData={options}
      {...rest}
    />
  );
};

const locale = {
  en: {
    fieldMap: 'Field map',
    fieldMapDescription: 'Receive value from a field in journey',
    selectLabel: 'Select value',
    placeholder: 'Select or add',
    selectValue: 'Select value',
    manuallySelectValue: 'Manually select the value',
    add: 'Add',
  },
};
